import { countryName, normalizeCountry } from '@/lib/country'

// Small country flag (SVG files live in /public/flags, named by lower-case ISO code: in.svg, us.svg ...).
// Real images instead of flag emoji, because Windows browsers cannot draw flag emoji (they show "IN").
// Renders nothing when the person has no country yet.
export function CountryFlag({ code, height = 14 }: { code?: string | null; height?: number }) {
  const cc = normalizeCountry(code)
  if (!cc) return null
  const name = countryName(cc)
  return (
    <img
      className="country-flag"
      src={`/flags/${cc.toLowerCase()}.svg`}
      alt={name}
      title={name}
      width={Math.round(height * 1.5)}
      height={height}
      loading="eager"
      decoding="async"
      draggable={false}
      onError={(e) => { e.currentTarget.style.display = 'none' }}
    />
  )
}
